import PropTypes from 'prop-types';
import { useErrors } from 'Components/Organisms/ErrorsProvider';
import Dropzone from 'Components/Atoms/Dropzone/Dropzone';

const VALID_FILE_TYPES = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

export default function ImportFileUpload(props) {
    const { onClose, onSubmit, onChangeProcessing, processing, importService, busyContent, children } = props;

    const { showUnknownError } = useErrors();

    const onUnloadFiles = async (file) => {
        const isValid = VALID_FILE_TYPES.includes(file?.type);
        if (!isValid) {
            return;
        }

        onChangeProcessing(true);
        try {
            const response = await importService(file);
            onSubmit(response);
        } catch (error) {
            showUnknownError(error);
            onClose();
        } finally {
            onChangeProcessing(false);
        }
    };
    const accept = VALID_FILE_TYPES.join(', ');

    return (
        <Dropzone
            className="h-full"
            accept={accept}
            isBusy={processing}
            busyContent={busyContent}
            onFileSelect={onUnloadFiles}
        >
            {children}
        </Dropzone>
    );
}

ImportFileUpload.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChangeProcessing: PropTypes.func.isRequired,
    processing: PropTypes.bool.isRequired,
    importService: PropTypes.func.isRequired,
    busyContent: PropTypes.node,
    children: PropTypes.node,
    disabled: PropTypes.bool,
};
